import { Model } from 'dva'
import { CommentRead } from '../../Service'
import { CommentsReducerState } from './types'

const initialState: CommentsReducerState = {
  list: [],
  isCommentModalOpen: false,
  commentsVisible: true,
  context: null, // { content_type, object_id }
}

const Comments: Model = {
  namespace: 'comments',
  state: initialState,
  effects: {},
  reducers: {
    toggleCommentModal: (state, action) => {
      const { open, context } = action.payload
      if (open) {
        return {
          ...state,
          isCommentModalOpen: true,
          context,
        }
      }
      return {
        ...state,
        isCommentModalOpen: false,
        context: null,
      }
    },
    toggleComments: (state, action) => {
      return {
        ...state,
        commentsVisible: !state?.commentsVisible,
      }
    },
    setList: (state, action) => {
      const list: CommentRead[] = action.payload
      return {
        ...state,
        list,
      }
    },
    resetComments: (state, action) => {
      return {
        ...state,
        ...initialState,
      }
    },
  },
}

export default Comments
